import { Col, Row } from 'reactstrap';
import { SectionTitle } from '../../../../components/text';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Select } from '@octano/global-ui';
import { useAcademicOffer } from './HeaderLoader';
import { useFormContext } from 'react-hook-form';

export function Header() {
  const { t } = useTranslation('configuration/academic-offer');

  const academicOffers = useAcademicOffer();
  const { setValue } = useFormContext();

  const texts = useMemo(
    () => ({
      title: t('title'),
      description: t('description'),
      specificParameters: t('specificParameters'),
      textRequired: t('textRequired'),
      form: {
        selectAcademicOffer: t('form.selectAcademicOffer'),
      },
    }),
    [t],
  );

  return (
    <Row>
      <Col xs={12}>
        <SectionTitle text={texts.title} />
        <span className="fs-16">{texts.description}</span>
      </Col>
      <Col xs={12} className="mt-4 d-flex align-items-center">
        <p className="border border-primary rounded-sm px-2 text-primary fs-14 mb-0">
          {texts.textRequired}
        </p>
        <span className="fs-16 ml-3">{texts.specificParameters}</span>
      </Col>
      <Col xs={12} md={6} className="mt-4">
        <Select
          label={texts.form.selectAcademicOffer}
          name="academicOffer"
          options={academicOffers ?? []}
          placeholder={texts.form.selectAcademicOffer}
          onChange={(value) => {
            setValue('selectedAcademicOffer', value);
          }}
        />
      </Col>
    </Row>
  );
}
